import { FormikProps } from "formik";
import { FC, ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Fields } from "../../types/SchemaFactory";

interface CustomRadioButtonProps {
    names: string[];
    form: FormikProps<any>;
    fields: Fields<any>;
    extraContentArray?: ReactNode[];
    extraHandlersArray?: CallableFunction[];
    firstWrapClassName?: string;
    secondWrapClassName?: string;
    thirdWrapClassName?: string;
    checkedRadioOuterClassName?: string;
    checkedRadioInnerClassName?: string;
    uncheckedRadioClassName?: string;
    extraLabelKeys?: string[];
    labelClassName?: string;
}

const CustomRadioButton: FC<CustomRadioButtonProps> = (props) => {
    const { t } = useTranslation();
    const radioButtonHandler = (currentName: string, index: number) => {
        return () => {
            props.names.forEach((name) => {
                props.form.setFieldValue(name, false);
            });
            props.form.setFieldValue(currentName, true);
            const extraCallback = props.extraHandlersArray?.at(index);
            if (extraCallback && typeof extraCallback === "function") {
                extraCallback();
            }
        };
    };

    return (
        <div className={`relative ${props.firstWrapClassName}`}>
            {props.names.map((name, index) => (
                <div key={`radio-button-${index}`} className={props.secondWrapClassName}>
                    <div onClick={radioButtonHandler(name, index)} className={props.thirdWrapClassName}>
                        {props.form.values[name] ? (
                            <div
                                className={`flex items-center justify-center cursor-pointer ${props.checkedRadioOuterClassName}`}
                            >
                                <div className={`rounded-full ${props.checkedRadioInnerClassName}`}></div>
                            </div>
                        ) : (
                            <div className={`rounded-full cursor-pointer ${props.uncheckedRadioClassName}`}></div>
                        )}
                        <label className={props.labelClassName}>
                            {t(props.extraLabelKeys ? props.extraLabelKeys[index] : props.fields[name].placeholderKey)}
                        </label>
                    </div>
                    {props.extraContentArray?.length === props.names.length && !!props.extraContentArray[index] && (
                        <div>{props.extraContentArray[index]}</div>
                    )}
                </div>
            ))}
        </div>
    );
};

export default CustomRadioButton;
